// Lightweight Plausible custom-event helper for funnel measurement.
//
// Why: the guest funnel (land → run → result → unlock → sign-in) changed a
// lot in the July conversion pass, and Clarity's text-based smart events
// can't tell the surfaces apart — especially now that every unlock CTA
// shares one label. These events name each step and carry the surface, so
// the funnel reads step-by-step in Plausible.
//
// The Plausible script is loaded with a queue shim (plausible-analytics.tsx),
// so calls made before the script arrives are queued, not lost. Events only
// appear in the dashboard as goals once a matching goal is created there —
// sending unknown events is harmless.
//
// Version the complete landing experience, separately from the retired
// subcopy-only experiment. No URLs or form contents are sent.
const CONVERSION_VERSION = "guest-preview-v2";

type Props = Record<string, string | number | boolean>;
type Plausible = ((e: string, opts?: { props?: Props }) => void) & { q?: unknown[][] };

export function track(event: string, props?: Props): void {
  try {
    const w = window as unknown as {
      plausible?: Plausible;
    };
    if (typeof w.plausible !== "function") {
      const queued: Plausible = (e, opts) => {
        (queued.q ??= []).push([e, opts]);
      };
      w.plausible = queued;
    }
    w.plausible(event, { props: { ...props, conversion_version: CONVERSION_VERSION } });
  } catch {
    // Analytics must never break the product.
  }
}
